import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

// This page redirects old /blog URLs to /substack
// since all articles are hosted on Substack
export function BlogPostPage() {
  const navigate = useNavigate();

  useEffect(() => {
    // Redirect to substack page
    navigate('/substack', { replace: true });
  }, [navigate]);

  return null;
}

export default BlogPostPage;
